import React, { Component } from 'react';
import { Formik, Form, Field, ErrorMessage, withFormik } from 'formik';
import * as yup from 'yup';
import { Row, Col } from 'react-bootstrap';
import { Link } from '@sitecore-jss/sitecore-jss-react';
import Heading from '../../heading/Heading';
import { FormCheckbox, FormInput, FormSelect } from '../elements';
export default (function (props) {
  var changeHandler = props.changeHandler,
      setFieldValue = props.setFieldValue,
      feedbackConcern = props.feedbackConcern,
      feedbackText = props.feedbackText,
      _props$terms = props.terms,
      terms = _props$terms === void 0 ? {} : _props$terms,
      _props$privacy = props.privacy,
      privacy = _props$privacy === void 0 ? {} : _props$privacy,
      values = props.values;
  var options = [{
    'label': 'Please Select One',
    'value': ''
  }, {
    'label': 'Restaurant',
    'value': 'Restaurant'
  }, {
    'label': 'Home Office',
    'value': 'Home Office'
  }, {
    'label': 'Employment',
    'value': 'Employment'
  }, {
    'label': 'Tour Groups',
    'value': 'Tour Groups'
  }, {
    'label': 'Other',
    'value': 'Other'
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Heading, {
    level: "2",
    field: {
      value: "What is your feedback concerning?"
    },
    className: "cb-type__title"
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
    value: values.feedbackConcern,
    name: "feedbackConcern",
    label: "What is your feedback concerning?",
    component: FormSelect,
    options: options
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
    value: values.feedbackText,
    name: "feedbackText",
    label: "What would you like us to know?",
    component: FormInput,
    className: "cb-form__input--full",
    changeFullHandler: changeHandler
  }))));
});